// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1ogeB","alertIcon":"ConfirmModal_alertIcon__3iTL4"};